export function redirectToHome() {
  window.location.href = `${window.REACT_APP_BASE_URL}`;
}
